import React from 'react';
import classNames from 'classnames';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import LoadingPlaceholder from '@lib/components/LoadingPlaceholder/LoadingPlaceholder';
import styles from './SiteMapPopupContent.module.scss';

export default function SiteMapPopupContentLoading() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.siteNameWrap}>
        <LoadingPlaceholder height={21} widthPercent={80} />
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.block,
        )}
      >
        <LoadingPlaceholder height={32} />
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.block,
        )}
      >
        <LoadingPlaceholder height={32} />
      </div>
      <div
        className={classNames(
          entityViewStyles.infoItem,
          entityViewStyles.block,
        )}
      >
        <LoadingPlaceholder height={32} />
      </div>
    </div>
  );
}
